import { DocumentProviderType } from 'models/documentProvider';
import { ReportSaveLocationDTO } from 'models/dto/library/reportSaveLocationDTO';
import { SaveCopilotFileToLibraryDTO } from 'models/dto/copilot/copilotFileBlockDTO';
import { ReportSaveLocation, ReportSaveRequest } from 'models/library/reportSaveLocation';

export function mapFromReportSaveLocation(dto: ReportSaveLocationDTO): ReportSaveLocation {
  const output = new ReportSaveLocation();
  output.listId = dto.listId ?? 0;
  output.listName = dto.listName ?? '';
  output.providerType = (dto.providerType ?? DocumentProviderType.SharePoint) as DocumentProviderType;
  output.folderId = dto.folderId || undefined;
  output.folderName = dto.folderName || undefined;
  output.fileName = dto.fileName ?? '';

  return output;
}

export function mapToReportSaveRequest(request: ReportSaveRequest): SaveCopilotFileToLibraryDTO {
  const output = new SaveCopilotFileToLibraryDTO();
  output.listId = request.listId;
  output.parentFolderId = request.parentFolderId;
  output.purpose = request.purpose;

  return output;
}
